import { startOfWeek } from 'date-fns'
import z from 'zod'

import { statisticsFilterSchema } from '@/dialogs/StatisticsSoundsFiltersDialog/validations.ts'

export const schema = z.object({
  priority: z.enum(['trending', 'most-posts']).optional(),
  countries: z.array(z.string()),
  statistics: statisticsFilterSchema.optional(),
  date: z.object({
    from: z.date(),
    to: z.date(),
  }),
})

export type TikTokSoundsFiltersForm = z.infer<typeof schema>

export const defaultValues: TikTokSoundsFiltersForm = {
  priority: 'trending',
  countries: [],
  date: {
    from: startOfWeek(new Date(), { weekStartsOn: 1 }),
    to: new Date(),
  },
}
